export enum DialogAction {
  submit = 'submit',
  cancel = 'cancel',
}
